// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MZE0pZvSy3bCl3thLAe8 {
  font-weight: 900;
}

.bxb1Kohcasui1spD5v92 {
  text-align: center;
}`, "",{"version":3,"sources":["webpack://./src/components/EmailVerify/components/EmailVerified/style.module.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB","sourcesContent":[".contentTitle {\n  font-weight: 900;\n}\n\n.contentDescription {\n  text-align: center;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"contentTitle": `MZE0pZvSy3bCl3thLAe8`,
	"contentDescription": `bxb1Kohcasui1spD5v92`
};
export default ___CSS_LOADER_EXPORT___;
